<template>
  <section class="hero-section">
    <div class="container">
      <div class="row align-items-center">
        <!-- Text -->
        <div class="col-lg-6 text-white hero-text" data-aos="fade-up">
          <p class="badge-text mb-3">
            <i class="fa-solid fa-thumbs-up me-2"></i>
            <span class="text-warning">100%</span> منصة تأجير سيارات موثوقة في العالم
          </p>
          <h1 class="fw-bold mb-4">
            <span class="text-warning">اعثر على أفضل</span><br />
            سيارة أحلامك للتأجير
          </h1>
          <p class="mb-4 text-muted">
            اختبر الأفضل في الراحة والأداء والأناقة مع خدمات تأجير السيارات الفاخرة لدينا.
            من السيدان الأنيقة والكوبية الأشيك إلى سيارات الدفع الرباعي الواسعة والكابريوليه الأنيقة،
            نقدم مجموعة من المركبات المميزة لتناسب تفضيلاتك ونمط حياتك.
          </p>
         <button
            class="btn btn-view d-inline-flex align-items-center"
            @click="goToAllCars"
          >
            عرض جميع السيارات
            <i class="feather-arrow-left ms-2"></i>
          </button>

        </div>

        <!-- Car Image-->
        <div class="col-lg-6 hero-image" data-aos="fade-up">
          <img
            src="@/assets/img/car-right.png"
            alt="car"
            class="img-fluid"
          />
        </div>
      </div>
    </div>
    <home-search />
  </section>

</template>
<script>
import HomeSearch from "@/views/frontend/pages/index-5/HomeSearch.vue";
import { useCarsStore } from "@/stores/cars-store";
import { useRouter } from "vue-router";
export default {
  components: {
    HomeSearch,
  },
    setup() {
    const carsStore = useCarsStore();
    const router = useRouter();

    const goToAllCars = () => {
      if (carsStore.clearFilters) {
          carsStore.resetFilters(); // Reset Filters
          }
      carsStore.fetchCars(); 
      router.push("/listing/listing-grid");
    };

    return { goToAllCars };
  },
};
</script>
<style scoped>
.hero-section {
  /* background: linear-gradient(to right, #0e3b2f, #2fa66b) !important; */
  padding: 80px 0;
  direction: rtl;
   margin-top: 0 !important;
  border-top: none !important;
  position: relative;

}

.hero-text h1 {
  font-size: 2.5rem;
  line-height: 1.4;
  color: white;
}

.text-warning {
  color: #ffc107 ; 
}

.text-muted {
  color: rgb(44, 62, 80);
  }

.badge-text {
  background-color: white;
  color: #ffcd38; 
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 20px;
  border-radius: 40px;
  font-weight: 600;
  font-size: 1rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  gap: 8px;
}

.badge-text .percent {
  color: #ffcd38; 
  font-weight: 700;
}

.badge-text i {
  color: #ffcd38; 
  font-size: 1rem;
}


.btn-view {
  background-color: #00c569;
  color: white;
  font-weight: bold;
  padding: 10px 20px;
  border-radius: 30px;
  transition: background 0.3s;
  font-size: 1rem;
  border-color: #00c569;
}

.btn-view:hover {
  background-color: #00a756;
  color: white;
}


.btn-view:hover {
  background-color: #00a756;
  color: white;
}

.hero-image img {
  max-width: 100%;
}
@media (max-width: 991px){
  .hero-section {
    padding: 0px;

  }
}
</style>